export default __webpack_public_path__ + "static/media/laptop-5.20350026.gif";